<template>
    <div>
        <div class="panel panel-default">
        <div class="panel-heading">
            <div class="btn-toolbar" role="toolbar">
                <div class="btn-group" >
                    <button @click="setupAndRun()" class="btn btn-success" :disabled="!session"><icon name="cogs"></icon> Compile & Run</button>
                    <button type="button" class="btn btn-success dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu">
                        <li><a href="#" @click="setup()"><icon name="cogs"></icon> Setup</a></li>
                    </ul>
                </div>
                <div class="btn-group">
                    <button @click="reset()" class="btn btn-default" :disabled="!session.scheduler || session.scheduler.isRunning()"><icon name="undo"></icon> Reset</button>
                </div>
                <div class="btn-group">
                    <button @click="run()" class="btn btn-default" :disabled="!session.scheduler || session.scheduler.isRunning()"><icon name="play-circle"></icon></button>
                    <button @click="pause()" class="btn btn-default" :disabled="!session.scheduler || !session.scheduler.isRunning()"><icon name="pause-circle"></icon></button>
                    <button @click="step()" class="btn btn-default" :disabled="!session.scheduler || !session.scheduler.isPaused()"><icon name="step-forward"></icon></button>
                    <button @click="tick()" class="btn btn-default" :disabled="!session.scheduler || !session.scheduler.isPaused()"><icon name="fast-forward"></icon></button>
                </div>

                <div class="btn-group" style="width: 256px">
                    <vue-slider 
                        v-model="speedValue"
                        :data="speedData"
                        :piecewise="true"
                        :piecewiseLabel="true"
                        tooltip="hover"
                        @callback="setSpeed"
                        :disabled="!session">
                    </vue-slider>
                </div>

                <div class="btn-group pull-right">
                    <checkbox v-model="session.showScheduler" :disabled="!session.scheduler" :button='true'><icon name="tasks" :title="session.scheduler ? session.scheduler.type.name : 'Scheduler not initialized'"/></checkbox>
                </div>

            </div>
        </div>
        <div class="panel-status" :class="statusClass">
            <span v-if="session.scheduler">
                    <icon :name="session.scheduler.state.icon"></icon> {{ session.scheduler.state.name }}
                    <span v-if="session.scheduler.isPaused()"> [<icon name="user-secret"></icon> {{ session.scheduler.nextExecutor.agent.name }}]</span>
                    <span v-if="session.scheduler.isError()"> [<icon name="user-secret"></icon> {{ session.scheduler.nextExecutor.agent.name }}] {{ session.scheduler.exception.message }}</span>
            </span>
            <span v-if="!session.scheduler">Please compile your code to run the simulation...</span>
        </div>
        <div class="panel-body">
            <div class="row">
                <div class="col-md-8">
                    <div id="parapple-canvas" class="simulator-canvas" />
                </div>
                <div class="col-md-4">
                    <schedulerPanel v-if="session.scheduler && session.showScheduler" :scheduler="session.scheduler"></schedulerPanel>    
                </div>
            </div>
        </div>
    </div>

    </div>

</template>

<script>

    import proxy from 'components/console/consoleProxy.js';
    import vueSlider from 'vue-slider-component';
    import schedulerPanel from 'components/workbench/simulator/schedulerPanel/SchedulerPanel';
    import schedulerShortcut from 'components/workbench/simulator/schedulerPanel/SchedulerShortcut';

    export default {
        name: "simulator",
        props: ["session"],
        data() {
            return {
                scheduler: null,
                speedValue: "1x",
                speedData: [
                    "1/8x",
                    "1/4x",
                    "1/2x",
                    "1x",
                    "2x",
                    "4x",
                    "8x",
                    "Max"
                ]
            }
        },
        mounted() {
            this.session.initialize();
            this.session.setSpeed(this.speedValue);
        },
        methods: {

            setupAndRun() {
                if (this.session.setup()) {
                    this.run();
                }
            },

            setup() {
                this.session.setup();
            },

            run() {
                if (this.session.scheduler.isDone()) {
                    this.session.reset();
                }
                this.session.scheduler.run();
            },

            step() {
                this.session.scheduler.debugStep();
            },
            tick() {
                this.session.scheduler.debugTick();
            },

            pause() {
                this.session.scheduler.pause();
            },

            reset() {
                this.session.reset();
            },

            setSpeed(value) {
                this.session.setSpeed(value);
            }

        },
        watch: {
            session() {
                this.session.initialize();
                this.session.setSpeed(this.speedValue);
            }
        },
        components: {
            vueSlider,
            schedulerPanel,
            schedulerShortcut
        },
        computed: {
            statusClass: function () {
                return this.session.scheduler 
                    ? "alert-" + this.session.scheduler.state.cssClass
                    : "";
            }
        }
    }
</script>

<style scoped>
    div.panel-status {
        border-bottom: 1px solid #ddd;;
        padding: 1px 10px;
    }
</style>


// WEBPACK FOOTER //
// Simulator.vue?4866eb3c